export default __webpack_public_path__ + "assets/acqLogo.835557cd.png";